module.exports = __webpack_public_path__ + "img/energy_logo.c6b8fb96.png";